const cliente = {
  readCliente: '{{uuid_academia}}/cliente-persona',
  updateCliente: '{{uuid_academia}}/cliente-persona',
}

export default cliente
